import { InAppMessage } from "../../../../model/model"
import Workspace from "../../../../workspace/Workspace"
import { HackleUser } from "../../../../model/model"
import { InAppMessageEvaluatorRequest } from "../InAppMessageEvaluatorRequest"

export class InAppMessageLayoutRequest extends InAppMessageEvaluatorRequest {
  constructor(readonly workspace: Workspace, readonly user: HackleUser, readonly inAppMessage: InAppMessage) {
    super()
  }

  static of(request: InAppMessageEvaluatorRequest): InAppMessageLayoutRequest {
    if (request instanceof InAppMessageLayoutRequest) return request

    return new InAppMessageLayoutRequest(request.workspace, request.user, request.inAppMessage)
  }

  toString(): string {
    return `InAppMessageLayoutRequest(type=${this.key.type}, key=${this.inAppMessage.key})`
  }
}
